module.exports = __webpack_public_path__ + "static/media/hero-bg1.1940aa5f.jpg";